import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';

export default class Karaoke extends AbstractScene {
    constructor() {
        super({
            key: "Karaoke"
        })
    }
    init(data) {
        this._init(data);
    }







    preload() {
        this._preload();
        this.videoKey = 'videoGenerique';
        this.preTarget = () => this.scene.start('EndVideo');
        this.postTarget = () => this.scene.start('KaraokeEnd');
        this.allControls = []
    }

    update() {
        if (this.isPlaying && !this.isDraging) {
            this.currentTiming = this.video.getCurrentTime()
            this.totalDuration = this.video.getDuration()
            this.slider.value = this.currentTiming / this.totalDuration
            const progress = this.video.getProgress();
            this.barFill.width = progress * 1527;
        } else if (this.isDraging) {
            const progress = this.video.getProgress();
            const duration = this.video.getDuration();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.barFill.width = this.slider.value * 1527;
        }
        if (this.isPlaying) {
            const duration = this.video.getDuration();
            const progress = this.video.getProgress();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.durationText.setText(this.formatTime(duration));
        }
    }


    create() {
        this.isDraging = false
        this.isPlaying = false
        this.isPaused = false;

        const blocker = this.add.rectangle(this.width / 2, this.height / 2, this.width, this.height, Colors.Elmt.Black)

        // 📹 1. Ajoute la vidéo
        this.video = this.add.video(0, 0, this.videoKey).setOrigin(0.5).setDepth(1);
        this.video.setPaused(true)

        // 2. On centre la vidéo au milieu du canvas
        this.video.setPosition(this.width / 2, this.height / 2);

        // ▶️ 3. Bouton Play au centre
        this.startButton = this.add
            .image(this.width / 2, this.height / 2, 'videoPlay')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .setDepth(3);
        this.startButton.setAlpha(1);
        this.allControls.push(this.startButton);

        // 🕹️ Animation au survol du bouton Play
        this.startButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.startButton,
                scale: 1.1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        this.startButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.startButton,
                scale: 1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        // Clique sur le bouton Play pour démarrer la vidéo
        this.startButton.on('pointerdown', () => {
            this.video.play();
            this.isPlaying = true;
            this.video.setMute(false);
            this.video.setVolume(1); // au cas où
            this.isPaused = false;
            this.startButton.setAlpha(0); // Cache le bouton play
            this.allControls.forEach(control => control.setVisible(true));
        });

        // ⏱️ Texte durée
        this.currentTimeText = this.add
            .text(1560, this.height - 150, '0:00', {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20).setVisible(false)
        this.allControls.push(this.currentTimeText);

        this.barretime = this.add
            .text(1590, this.height - 150, '/', {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20).setVisible(false)
        this.allControls.push(this.barretime);


        this.durationText = this.add
            .text(1620, this.height - 150, "0:00", {
                fontSize: "20px",
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5).setDepth(20).setVisible(false)
        this.allControls.push(this.durationText);


        this.sliderLine = this.add.rexRoundRectangle(this.width / 2, this.height - 100, 1528, 6, 3, Colors.Elmt.White).setAlpha(0.5).setDepth(20).setVisible(false)
        this.allControls.push(this.sliderLine);
        this.barFill = this.add.rexRoundRectangle(this.width / 2 - 764, this.height - 100, 0, 6, 3, Colors.Elmt.White).setOrigin(0, 0.5).setDepth(20).setVisible(false)
        this.allControls.push(this.barFill);
        this.sliderLine.setSize(1528, this.sliderLine.height)
        this.sliderLine.setInteractive({ useHandCursor: true });
        this.sliderLine.on('pointerdown', (event) => {
            let a = event.x
            let b = this.sliderLine.x
            let c = a - b
            let value = (c + 764) / 1528
            this.barFill.width = value * 1528
            this.slider.value = value
            this.video.seekTo(value);
        })
        this.sliderButton = this.add.circle(this.width / 2 - 764, this.height - 100, 15, Colors.Elmt.White).setInteractive({ useHandCursor: true }).setAlpha(1).setDepth(20).setVisible(false)
        this.allControls.push(this.sliderButton);
        this.sliderButton.setStrokeStyle(4, Colors.Elmt.White)
        this.sliderButton.on('pointerdown', () => {
            this.isDraging = true
            this.isPlaying = false
            this.video.setPaused(true)
        })
        this.sliderButton.on('pointerup', () => {
            this.isDraging = false
            if (this.isPaused) {
                this.isPlaying = false
                this.video.setPaused(true)
            } else {
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.input.on('pointerup', () => {
            if (this.isDraging) {
                this.isDraging = false
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.slider = this.plugins.get('rexSlider').add(this.sliderButton, {
            endPoints: [
                { x: this.sliderLine.x - 764, y: this.sliderLine.y },
                { x: this.sliderLine.x + 764, y: this.sliderLine.y }
            ],
            value: 0,
            enable: true,
            valuechangeCallback: (value) => {
                if (this.isDraging) {
                    // console.log("Slider value", value);
                    this.video.seekTo(value);
                }
            }
        });

        // 📥 Sur fin de la vidéo
        let hasEnded = false;

        this.video.on('complete', () => {
            hasEnded = true;
            this.postTarget(this);
        });

        // Clique sur la vidéo pour la mettre en pause ou reprendre
        this.video.setInteractive();
        this.video.on('pointerdown', () => {
            if (hasEnded) return;
            // Si la vidéo est en pause, la reprendre
            if (this.isPaused) {
                this.video.resume();
                this.startButton.setAlpha(0); // Cacher le bouton Play
                this.isPaused = false;
                this.isPlaying = true
            } else {
                // Sinon, mettre la vidéo en pause
                this.video.pause();
                this.startButton.setAlpha(1); // Montrer le bouton Play
                this.isPlaying = false
                this.isPaused = true;
            }

        });

        this.buttonReculer = this.add
            .image(100, this.height - 100, 'videoBack')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {

                this.preTarget(this)
            })
            .setVisible(false)
            .setDepth(20);
        this.allControls.push(this.buttonReculer);

        this.buttonAvancer = this.add
            .image(this.width - 100, this.height - 100, 'videoNext')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.postTarget(this)
            })
            .setVisible(false)
            .setDepth(20);
        this.allControls.push(this.buttonAvancer);


    }


    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}